import { Component, Inject, OnInit } from '@angular/core';
import { MarketplaceManagerService } from 'src/app/services/marketplace-manager.service';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SubscriptionKeyType } from 'src/app/types/marketplace-manager.type';

@Component({
  selector: 'app-view-subscription-key',
  template: `
    <div class="sb-head">
      <div class="t">
        <h2>Subscribers</h2>
        <p>{{ data.solution_name || 'Solution' }} · issued subscription keys</p>
      </div>
      <span class="sb-x" mat-dialog-close><mat-icon>close</mat-icon></span>
    </div>

    <mat-dialog-content class="sb-body">
      <div *ngIf="availableSubsKeys.length < 1" class="sb-empty">
        <mat-icon>group_off</mat-icon>
        <span>No subscription keys issued for this solution yet.</span>
      </div>

      <div class="sub-row" *ngFor="let subsKey of availableSubsKeys">
        <span class="uav">{{ (subsKey?.username || '?')[0] | uppercase }}</span>
        <div class="sub-mid">
          <div class="sub-nm">{{ subsKey?.username }}</div>
          <div class="sub-meta">
            Tenant {{ subsKey?.tenant }} · issued {{ getDate(subsKey.created_dtm) }}
          </div>
        </div>
        <span class="st-pill st-pub" *ngIf="subsKey?.is_active !== false">Active</span>
        <span class="st-pill st-off" *ngIf="subsKey?.is_active === false">Inactive</span>
        <button
          class="cp"
          matTooltip="Copy token"
          (click)="copyTextToClipboard(subsKey['subscription_key'])"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </mat-dialog-content>

    <div class="sb-foot">
      <button class="btn-ghost" mat-dialog-close>Close</button>
    </div>
  `,
  styleUrls: ['./view-subscription-key.component.scss'],
})
export class ViewSubscriptionKeyComponent implements OnInit {
  availableSubsKeys: SubscriptionKeyType[]=[];
  constructor(
    private sharedServices: SharedFeaturesService,
    private marketPlaceManagerServices: MarketplaceManagerService,
    private clipboard: Clipboard,
    @Inject(MAT_DIALOG_DATA) public data: {solution_id: string; solution_name?: string} = {solution_id: ''},
  ) {}

  ngOnInit(): void {
    this.marketPlaceManagerServices.getSubscriptionKey(this.data?.solution_id).subscribe({
      next: (response: any) => {
        this.availableSubsKeys = response?.msg;
        this.availableSubsKeys.sort((a, b) => {
          const dateA = new Date(a.created_dtm);
          const dateB = new Date(b.created_dtm);
          return dateB.getTime() - dateA.getTime();
        });
      },
      error: (error: any) => {
        console.error('An error occurred', error);
      },
    });
  }

  getDate(date:string){
    return this.sharedServices.convertTimeStamp(date)
  }

  copyTextToClipboard(data: string): void {
    this.clipboard.copy(data);
    this.sharedServices.openSnackBar(
      'token copied',
      'Close',
      'success-snackbar'
    );
  }
}
